import React from "react";
import CustomParagraph from "./CustomParagraph";
import CustomButton from "./CustomButton";
import { Flex, Dropdown, Button, Menu, Divider } from "antd";
import phoneAi from "../../src/assets/images/Aiphone.svg";
import UseAi from "../assets/images/UseAi";
import ExpandMore from "../assets/images/ExpandMore";
import { marked } from "marked";
import { useNavigate } from "react-router-dom";

function StatusCardNotification({
  showButtons = true,
  cardStyle,
  icon,
  createdAt,
  title,
  description,
  shipment,
  bgColor,
  color,
  actionButtonText,
  actionButtonWidth,
  actionButtonBorderRadius,
  actionButtonBgColor,
  actionButtonOnClick,
  dismissAction,
  aiOptions = [],
  aiStatus,
  useAiButton,
  isCritical,
}) {
  const navigate = useNavigate();
  const isAiInProgress =
    aiStatus === "ai_call_in_progress" || aiStatus === "ai_email_in_progress";

  const processedDescription = description
    ? description.replace(/\\n/g, "\n")
    : "";

  const aiDropdownItems = aiOptions.map((item) => ({
    key: item.key,
    disabled: item.disabled,
    label: (
      <Flex align="center" gap={8}>
        <div style={{ opacity: item.disabled ? 0.4 : 1, color: "black" }}>
          {item.icon}
        </div>
        <span
          style={{
            fontSize: "12px",
            fontWeight: 400,
            color: item.disabled ? "#BFBFBF" : "#000",
          }}
        >
          {item.label}
        </span>
      </Flex>
    ),
  }));

  const menu = (
    <div
      className="custom-ai-dropdown"
      style={{ backgroundColor: "#fff", width: "200px" }}
    >
      <Menu
        items={aiDropdownItems}
        onClick={({ key }) => {
          const selectedItem = aiOptions.find((item) => item.key === key);
          if (selectedItem && !selectedItem.disabled) {
            selectedItem.onClick();
          }
        }}
      />
{shipment?.tp_primary_contact &&
<>
      {!shipment?.tp_primary_contact?.email &&  (
        <>
          <Divider style={{ margin: "0px 0" }} />
          <div className="ai-dropdown-footer">
            <div className="footer-text">
              Add transport provider contact details to use AI
            </div>

            {/* {!shipment?.tp_primary_contact ? ( */}
              <Button
                type="default"
                icon={
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 9.5H2.5V2.5H6V1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.945 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6H9.5V9.5ZM7 1.5V2.5H8.795L3.88 7.415L4.585 8.12L9.5 3.205V5H10.5V1.5H7Z"
                      fill="white"
                    />
                  </svg>
                }
                style={{
                  width: "100%",
                  height: "28px",
                  backgroundColor: "#000",
                  color: "#fff",
                  marginTop: 6,
                  fontWeight: 500,
                  fontSize: 12,
                  borderRadius: 8,
                }}
                onClick={() => {
                  const courierId = shipment?.tp_primary_contact?.company_courier_id;
                  if (courierId) {
                    navigate(`/settings/couriers?openDrawer=true&id=${courierId}`);
                  }
                }}
              >
                Add details
              </Button>
            {/* // ) : (
            //   <Tooltip title={"Please add transport provider"}>
            //     <span>
            //       <Button
            //         type="default"
            //         disabled={true}
            //         icon={
            //           <svg
            //             width="12"
            //             height="12"
            //             viewBox="0 0 12 12"
            //             fill="none"
            //             xmlns="http://www.w3.org/2000/svg"
            //           >
            //             <path
            //               d="M9.5 9.5H2.5V2.5H6V1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.945 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6H9.5V9.5ZM7 1.5V2.5H8.795L3.88 7.415L4.585 8.12L9.5 3.205V5H10.5V1.5H7Z"
            //               fill="#a5a5a5"
            //             />
            //           </svg>
            //         }
            //         style={{
            //           width: "100%",
            //           height: "28px",
            //           backgroundColor: "#5e5e5e",
            //           color: "#a5a5a5",
            //           marginTop: 6,
            //           fontWeight: 500,
            //           fontSize: 12,
            //           borderRadius: 8,
            //         }}
            //       >
            //         Add details
            //       </Button>
            //     </span>
            //   </Tooltip>
            // )} */}
          </div>
        </>
      )}
</>}

    </div>
  );

  const CardContent = (
    <Flex
      align="center"
      justify="space-between"
      gap={cardStyle === "style-2" ? 8 : 16}
      vertical={cardStyle === "style-2"}
      style={{
        padding: "16px",
        background: isAiInProgress
          ? "linear-gradient(0deg, #ffffff 0%, #f2faff 100%)"
          : bgColor,
        borderRadius: isAiInProgress ? "9px" : "12px",
      }}
    >
      <Flex gap={16} align="center" style={{ width: "100%" }}>
        {isAiInProgress ? (
          <img
            src={phoneAi}
            alt="AI call preview"
            preview={false}
            style={{
              width: "24px",
              height: "24px",
              objectFit: "contain",
              flexShrink: 0,
              display: "block",
            }}
          />
        ) : (
          icon
        )}

        <div>
          <CustomParagraph
            text={title}
            fontSize={12}
            fontWeight={600}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="4px"
          />
          <CustomParagraph
            htmlString={
              processedDescription
                ? marked(processedDescription, { breaks: true })
                : ""
            }
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="0"
          />
          <CustomParagraph
            text={createdAt}
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="0"
          />
        </div>
      </Flex>

      {!isAiInProgress && (
        <>
          {showButtons === true && cardStyle === "style-1" && (
            <CustomButton
              text={actionButtonText}
              width="auto"
              padding="5px 15px"
              height="36px"
              color={color}
              bgColor={actionButtonBgColor}
              borderRadius={actionButtonBorderRadius}
              marginBottom="0"
              boxShadow="none"
              onClick={actionButtonOnClick}
            />
          )}

          {cardStyle === "style-2" && (
            <Flex gap={8} justify="flex-end" style={{ width: "100%" }}>
              <CustomButton
                text="Dismiss"
                width="auto"
                padding="5px 15px"
                fontSize={"12px"}
                fontWeight={"600"}
                height={36}
                color={color}
                bgColor={"initial"}
                boxShadow={"none"}
                onClick={dismissAction}
              />

              <CustomButton
                text={actionButtonText}
                width="auto"
                fontSize={"12px"}
                fontWeight={"600"}
                padding="5px 15px"
                height="36px"
                color={color}
                bgColor={actionButtonBgColor}
                borderRadius={actionButtonBorderRadius}
                marginBottom="0"
                boxShadow="none"
                onClick={actionButtonOnClick}
              />

              {aiOptions?.length > 0 && useAiButton && (
                // <Dropdown
                //   className="useAiDropdown"
                //   menu={{
                //     items: aiDropdownItems,
                //     onClick: ({ key }) => {
                //       const selectedItem = aiOptions.find(
                //         (item) => item.key === key
                //       );
                //       if (selectedItem && !selectedItem.disabled) {
                //         selectedItem.onClick();
                //       }
                //     },
                //   }}
                //   placement="bottomRight"
                // >
                //   <Button
                //     style={{
                //       height: "36px",
                //       backgroundColor: !isCritical
                //         ? "#FBE5B6"
                //         : "rgb(187 3 42)",
                //       borderRadius: "8px",
                //       fontSize: "12px",
                //       fontWeight: 600,
                //       padding: "0 12px",
                //       display: "flex",
                //       alignItems: "center",
                //       gap: "6px",
                //       border: "none",
                //       boxShadow: "none",
                //       outline: "none",
                //     }}
                //   >
                //     <UseAi color={isCritical === false ? "#000" : "#fff"} />
                //     <span
                //       className={isCritical ? "white" : "black"}
                //       style={{
                //         fontSize: "12px",
                //         fontWeight: 600,
                //       }}
                //     >
                //       Use AI
                //     </span>
                //     <ExpandMore
                //       color={isCritical === false ? "#000" : "#fff"}
                //     />
                //   </Button>
                // </Dropdown>

                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  className="useAiDropdown"
                >
                  <Button
                    style={{
                      height: "36px",
                      backgroundColor: !isCritical
                        ? "#FBE5B6"
                        : "rgb(187 3 42)",
                      borderRadius: "8px",
                      fontSize: "12px",
                      fontWeight: 600,
                      padding: "0 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      border: "none",
                      boxShadow: "none",
                      outline: "none",
                    }}
                  >
                    <UseAi color={isCritical === false ? "#000" : "#fff"} />
                    <span
                      className={isCritical ? "white" : "black"}
                      style={{ fontSize: "12px", fontWeight: 600 }}
                    >
                      Use AI
                    </span>
                    <ExpandMore
                      color={isCritical === false ? "#000" : "#fff"}
                    />
                  </Button>
                </Dropdown>
              )}
            </Flex>
          )}
        </>
      )}
    </Flex>
  );

  return isAiInProgress ? (
    <div
      style={{
        background: "linear-gradient(90deg, #065DFF, #1C82D1, #42C47F)",
        padding: "3px",
        borderRadius: "12px",
        width: "100%",
      }}
    >
      {CardContent}
    </div>
  ) : (
    CardContent
  );
}

export default StatusCardNotification;
